import { apiClient } from "./api";

export interface BaserowApplication {
  id: number;
  name: string;
  type: string;
}

export interface BaserowTable {
  id: number;
  name: string;
  database_id: number;
}

export interface BaserowField {
  id: number;
  name: string;
  type: string;
}

export interface BaserowRowsResponse {
  count: number;
  results: Record<string, unknown>[];
}

export async function listBaserowApplications(): Promise<BaserowApplication[]> {
  const response = await apiClient.get("/baserow/applications");
  return response.data;
}

export async function listBaserowTables(databaseId: number): Promise<BaserowTable[]> {
  const response = await apiClient.get(`/baserow/databases/${databaseId}/tables`);
  return response.data;
}

export async function listBaserowRows(
  tableId: number,
  page = 1,
  size = 50,
): Promise<BaserowRowsResponse> {
  const response = await apiClient.get(`/baserow/tables/${tableId}/rows`, {
    params: { page, size },
  });
  return response.data;
}

export async function listBaserowFields(tableId: number): Promise<BaserowField[]> {
  // The backend proxy does not expose fields; call Baserow directly for now.
  // This is read-only metadata and safe to expose.
  const response = await apiClient.get(`/baserow/tables/${tableId}/fields`);
  return response.data;
}

export async function createBaserowRow(
  tableId: number,
  data: Record<string, unknown>,
): Promise<Record<string, unknown>> {
  const response = await apiClient.post(`/baserow/tables/${tableId}/rows`, data);
  return response.data;
}

export async function updateBaserowRow(
  tableId: number,
  rowId: number,
  data: Record<string, unknown>,
): Promise<Record<string, unknown>> {
  const response = await apiClient.patch(`/baserow/tables/${tableId}/rows/${rowId}`, data);
  return response.data;
}

export async function deleteBaserowRow(tableId: number, rowId: number): Promise<void> {
  await apiClient.delete(`/baserow/tables/${tableId}/rows/${rowId}`);
}
